import { merge, type MonoTypeOperatorFunction, type Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export function restartOn<T>(notifier$: Observable<any>): MonoTypeOperatorFunction<T> {
    return (source$: Observable<T>) => merge(of(null), notifier$).pipe(switchMap(() => source$));
}
